/* The shelf.
 *
 * One JSON file per book in ./books, and this is the running order -- the
 * pile is read top to bottom, so the sequence is content, not an accident of
 * the filesystem. Adding a book is: drop a cover in /public/covers, write the
 * JSON beside its siblings, add it to the list below.
 *
 * Imported rather than read from disk because the WebGL scene needs the shelf
 * in the browser, not just at build time. That costs one line per book and
 * keeps the whole thing a plain static import.
 *
 * See ./books/README.md for the shape of a file.
 */

import atomicHabits from './books/atomic-habits.json';
import deepWork from './books/deep-work.json';
import designingDataIntensiveApplications from './books/designing-data-intensive-applications.json';
import cleanCode from './books/clean-code.json';
import thePragmaticProgrammer from './books/the-pragmatic-programmer.json';
import thinkingFastAndSlow from './books/thinking-fast-and-slow.json';
import staffEngineer from './books/staff-engineer.json';
import systemDesignInterview from './books/system-design-interview.json';
import fourThousandWeeks from './books/four-thousand-weeks.json';
import thePsychologyOfMoney from './books/the-psychology-of-money.json';
import theStoriesOfRayBradbury from './books/the-stories-of-ray-bradbury.json';
import unbroken from './books/unbroken.json';
import steveJobs from './books/steve-jobs.json';
import braveNewWorld from './books/brave-new-world.json';
import lordOfTheFlies from './books/lord-of-the-flies.json';
import book1984 from './books/1984.json';
import animalFarm from './books/animal-farm.json';
import weAreBellingcat from './books/we-are-bellingcat.json';
import howToWinFriendsAndInfluencePeople from './books/how-to-win-friends-and-influence-people.json';
import elonMusk from './books/elon-musk.json';
import fahrenheit451 from './books/fahrenheit-451.json';
import theGreatGatsby from './books/the-great-gatsby.json';
import prideAndPrejudice from './books/pride-and-prejudice.json';
import thePhoenixProject from './books/the-phoenix-project.json';
import theSubtleArtOfNotGivingAFCk from './books/the-subtle-art-of-not-giving-a-f-ck.json';
import toKillAMockingbird from './books/to-kill-a-mockingbird.json';
import neverSplitTheDifference from './books/never-split-the-difference.json';
import thePowerOfHabit from './books/the-power-of-habit.json';
import whoMovedMyCheese from './books/who-moved-my-cheese.json';
import the4HourWorkweek from './books/the-4-hour-workweek.json';
import blueOceanStrategy from './books/blue-ocean-strategy.json';
import startWithWhy from './books/start-with-why.json';
import hooked from './books/hooked.json';
import goodToGreat from './books/good-to-great.json';
import the48LawsOfPower from './books/the-48-laws-of-power.json';
import richDadPoorDad from './books/rich-dad-poor-dad.json';
import theHardThingAboutHardThings from './books/the-hard-thing-about-hard-things.json';
import theRichestManInBabylon from './books/the-richest-man-in-babylon.json';
import cantHurtMe from './books/cant-hurt-me.json';
import pegasus from './books/pegasus.json';
import moneyMen from './books/money-men.json';
import veryBadPeople from './books/very-bad-people.json';
import thePanamaPapers from './books/the-panama-papers.json';
import russiansAmongUs from './books/russians-among-us.json';
import freezingOrder from './books/freezing-order.json';
import sandworm from './books/sandworm.json';
import tracersInTheDark from './books/tracers-in-the-dark.json';
import builtToLast from './books/built-to-last.json';
import foundation from './books/foundation.json';
import theLazarusHeist from './books/the-lazarus-heist.json';
import putinsPeople from './books/putins-people.json';
import butlerToTheWorld from './books/butler-to-the-world.json';
import howSpiesThink from './books/how-spies-think.json';
import letsTalk from './books/lets-talk.json';
import theHobbit from './books/the-hobbit.json';
import wutheringHeights from './books/wuthering-heights.json';
import greenlights from './books/greenlights.json';
import theSocialContract from './books/the-social-contract.json';
import theCreativeAct from './books/the-creative-act.json';
import lettersFromAStoic from './books/letters-from-a-stoic.json';
import theArtOfWar from './books/the-art-of-war.json';
import theStranger from './books/the-stranger.json';
import theSymposium from './books/the-symposium.json';
import meditations from './books/meditations.json';
import thusSpokeZarathustra from './books/thus-spoke-zarathustra.json';
import dontBelieveEverythingYouThink from './books/dont-believe-everything-you-think.json';
import freakonomics from './books/freakonomics.json';
import sapiens from './books/sapiens.json';
import the7HabitsOfHighlyEffectivePeople from './books/the-7-habits-of-highly-effective-people.json';
import matilda from './books/matilda.json';
import theGivingTree from './books/the-giving-tree.json';
import wonka from './books/wonka.json';
import charlottesWeb from './books/charlottes-web.json';
import theFaultInOurStars from './books/the-fault-in-our-stars.json';
import shoeDog from './books/shoe-dog.json';
import theEverythingStore from './books/the-everything-store.json';
import architecturePatternsWithPython from './books/architecture-patterns-with-python.json';
import buildingEventDrivenMicroservices from './books/building-event-driven-microservices.json';
import buildingEvolutionaryArchitectures from './books/building-evolutionary-architectures.json';
import buildingGreenSoftware from './books/building-green-software.json';
import buildingMedallionArchitectures from './books/building-medallion-architectures.json';
import buildingMicroservices from './books/building-microservices.json';
import buildingMultiTenantSaasArchitectures from './books/building-multi-tenant-saas-architectures.json';
import designingDistributedSystems from './books/designing-distributed-systems.json';
import facilitatingSoftwareArchitecture from './books/facilitating-software-architecture.json';
import flowArchitectures from './books/flow-architectures.json';
import fundamentalsOfEnterpriseArchitecture from './books/fundamentals-of-enterprise-architecture.json';
import learningApiStyles from './books/learning-api-styles.json';
import learningDomainDrivenDesign from './books/learning-domain-driven-design.json';
import learningSystemsThinking from './books/learning-systems-thinking.json';
import masteringApiArchitecture from './books/mastering-api-architecture.json';
import semanticSoftwareDesign from './books/semantic-software-design.json';
import theSoftwareArchitectElevator from './books/the-software-architect-elevator.json';
import softwareArchitectureTheHardParts from './books/software-architecture-the-hard-parts.json';
import softwareArchitectureMetrics from './books/software-architecture-metrics.json';

const shelf = [
  atomicHabits,
  deepWork,
  designingDataIntensiveApplications,
  cleanCode,
  thePragmaticProgrammer,
  thinkingFastAndSlow,
  staffEngineer,
  systemDesignInterview,
  fourThousandWeeks,
  thePsychologyOfMoney,
  theStoriesOfRayBradbury,
  unbroken,
  steveJobs,
  braveNewWorld,
  lordOfTheFlies,
  book1984,
  animalFarm,
  weAreBellingcat,
  howToWinFriendsAndInfluencePeople,
  elonMusk,
  fahrenheit451,
  theGreatGatsby,
  prideAndPrejudice,
  thePhoenixProject,
  theSubtleArtOfNotGivingAFCk,
  toKillAMockingbird,
  neverSplitTheDifference,
  thePowerOfHabit,
  whoMovedMyCheese,
  the4HourWorkweek,
  blueOceanStrategy,
  startWithWhy,
  hooked,
  goodToGreat,
  the48LawsOfPower,
  richDadPoorDad,
  theHardThingAboutHardThings,
  theRichestManInBabylon,
  cantHurtMe,
  pegasus,
  moneyMen,
  veryBadPeople,
  thePanamaPapers,
  russiansAmongUs,
  freezingOrder,
  sandworm,
  tracersInTheDark,
  builtToLast,
  foundation,
  theLazarusHeist,
  putinsPeople,
  butlerToTheWorld,
  howSpiesThink,
  letsTalk,
  theHobbit,
  wutheringHeights,
  greenlights,
  theSocialContract,
  theCreativeAct,
  lettersFromAStoic,
  theArtOfWar,
  theStranger,
  theSymposium,
  meditations,
  thusSpokeZarathustra,
  dontBelieveEverythingYouThink,
  freakonomics,
  sapiens,
  the7HabitsOfHighlyEffectivePeople,
  matilda,
  theGivingTree,
  wonka,
  charlottesWeb,
  theFaultInOurStars,
  shoeDog,
  theEverythingStore,
  architecturePatternsWithPython,
  buildingEventDrivenMicroservices,
  buildingEvolutionaryArchitectures,
  buildingGreenSoftware,
  buildingMedallionArchitectures,
  buildingMicroservices,
  buildingMultiTenantSaasArchitectures,
  designingDistributedSystems,
  facilitatingSoftwareArchitecture,
  flowArchitectures,
  fundamentalsOfEnterpriseArchitecture,
  learningApiStyles,
  learningDomainDrivenDesign,
  learningSystemsThinking,
  masteringApiArchitecture,
  semanticSoftwareDesign,
  theSoftwareArchitectElevator,
  softwareArchitectureTheHardParts,
  softwareArchitectureMetrics,
];

/* A book reaches the production site once it has a review. Until then it
   shows in development only, the way draft articles do, so the shelf can be
   worked through a few books at a time. */
export const isPublished = book => (book.review?.length ?? 0) > 0;
export const books = shelf.filter(
  book => process.env.NODE_ENV !== 'production' || isPublished(book)
);

export const getBook = slug => books.find(book => book.slug === slug) || null;
